<template>
  <anchor-link
    :href="href"
    :is-target-blank="isTargetBlank"
    :class="{'link--is-color-white': isColorWhite}"
    :rel="rel"
    class="link"
  >
    <span class="link__text">{{ title }}</span>
    <icon-angle-bracket
      :is-thin="true"
      class="link__icon"/>
  </anchor-link>
</template>

<script>
import { titledLinkProps } from '@/mikan/_shared/types/vueTypes/anchorLink';
import IconAngleBracket from '@/mikan/_shared/components/atoms/icons/IconAngleBracket.vue';
import AnchorLink from '@/mikan/_shared/components/atoms/AnchorLink.vue';

export default {
  components: {
    IconAngleBracket,
    AnchorLink,
  },
  props: {
    ...titledLinkProps,
    isColorWhite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rel() {
      return this.isTargetBlank ? 'noopener' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.link {
  display: inline-flex;
  align-items: center;
  color: $color-text-link;
  line-height: 1.2;
  transition: color $transition-interaction;

  @include is-pointer-device {
    &:hover {
      color: $color-text-link-hover;
    }
  }

  &__text {
    flex: 0 0 auto;
    line-height: 1;
  }

  &__icon {
    display: block;
    flex: 0 0 auto;
    margin-left: px-to-em(6px);
    font-size: px-to-em(10px);
    transform: translateY(px-to-em(0.3px));
  }

  &--is-color-white {
    color: $color-white;
  }
}
</style>
